import http from '@/libs/http'
const baseUrl = process.env.VUE_APP_MICROSERVICE_API_DASHBOARD_HUS
export default class Service {
  getData (payload = {}) {
    return http.get(`${baseUrl}/operaciones/remisiones-vs-facturas`, {
      params: payload,
      headers: {
        loading: true
      }
    })
  }
}
